export default "__VITE_ASSET__1c51a7e1__"